import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPlay"><Path d="M19.9016 9.48786L10.3899 3.2788C8.39443 1.97623 5.75 3.40798 5.75 5.79094V18.2091C5.75 20.592 8.39442 22.0238 10.3899 20.7212L19.9016 14.5121C21.7151 13.3283 21.7151 10.6717 19.9016 9.48786Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPlay;
